"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.verifySignature = void 0;
const near_api_js_1 = require("near-api-js");
const borsh_1 = require("borsh");
const js_sha256_1 = require("js-sha256");
const payload_1 = require("./payload");
const verifySignature = ({ publicKey, signature, message, nonce, recipient, callbackUrl }) => {
    const payload = new payload_1.Payload({ message, nonce, recipient, callbackUrl });
    const borshPayload = (0, borsh_1.serialize)(payload_1.payloadSchema, payload);
    const hashedPayload = Uint8Array.from(js_sha256_1.sha256.array(borshPayload));
    const realSignature = Buffer.from(signature, "base64");
    const pk = near_api_js_1.utils.PublicKey.from(publicKey);
    return pk.verify(hashedPayload, realSignature);
};
exports.verifySignature = verifySignature;
